import React from 'react';
import styled from '@emotion/styled';
import CrossDockIcon from './CrossDockIcon';
import AlzaIcon from '../../assets/AlzaIcon';
import MallIcon from '../../assets/MallIcon';
import AllegroIcon from '../../assets/AllegroIcon';
import { DeliveryManager } from '../../api/apiTypes';
import logisticAggregatorLogo from '../../assets/logistic_aggregator_logo.svg';

interface Props {
  carrier: string;
  deliveryManager: DeliveryManager;
  apiGroup: string;
  crossDockDelivery: boolean;
  orderId: number;
}

const Container = styled.div`
  display: flex;
  
  div:first-of-type {
    flex: 1 1 auto;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  div:last-child {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

function BrandIcon({ apiGroup }: { apiGroup: string }): React.ReactElement | null {
  switch (apiGroup) {
    case 'ALZA':
      return <AlzaIcon />;
    case 'MALL_GROUP':
      return <MallIcon />;
    case 'ALLEGRO':
      return <AllegroIcon />;
    default:
      return null;
  }
}

function LogisticAggregatorIcon(): React.ReactElement {
  return (
    <img
      src={logisticAggregatorLogo}
      width={20}
      height={20}
      alt="Logistic aggregator icon"
    />
  );
}

export default function CarrierCell({
  carrier,
  deliveryManager,
  apiGroup,
  crossDockDelivery,
  orderId,
}: Props) {
  return (
    <Container>
      <div>{carrier}</div>
      <div>
        {deliveryManager === DeliveryManager.MARKETPLACE && <BrandIcon apiGroup={apiGroup} />}
        {deliveryManager === DeliveryManager.MPI && <LogisticAggregatorIcon />}
        {crossDockDelivery && <CrossDockIcon orderId={orderId} />}
      </div>
    </Container>
  );
}
